import ApplicationAdapter from './application';

export default class Reaction extends ApplicationAdapter {
  modelNamePlural = 'reactions';
}
